import { Component, Type } from "@wonderlandengine/api";

export class Fullscreen extends Component {
  static TypeName = "fullscreen";
  static Properties = {
    disableXrButtonOnFullscreen: { type: Type.Bool, default: true },
  };

  init() {
    this.createDynamicHtml();
    this.vrButton = document.getElementById("vr-button");
    this.arButton = document.getElementById("ar-button");
  }

  update() {
    if (this.disableXrButtonOnFullscreen) this.UpdateXrIconVisibility();
  }

  createDynamicHtml() {
    const iconFullscreenSrc = "images/icon-fullscreen.png";
    const iconFullscreen = document.createElement("img");
    iconFullscreen.src = iconFullscreenSrc;
    iconFullscreen.draggable = "false";
    iconFullscreen.type = "button";
    iconFullscreen.id = "fullscreen";
    iconFullscreen.setAttribute(
      "onclick",
      "if(window.fullscreenFlag==null)window.fullscreenFlag=true;else window.fullscreenFlag=!window.fullscreenFlag; if(document.fullscreenElement) {document.exitFullscreen().then(() => {}).catch((err) => console.error(err))} else {document.documentElement.requestFullscreen();}"
    );
    iconFullscreen.setAttribute("data-loaded", "false");
    iconFullscreen.setAttribute(
      "style",
      "border:10px; bottom:10px; height:50px;width:50px;right:5px; position:absolute;"
    );
    document.body.appendChild(iconFullscreen);
  }

  UpdateXrIconVisibility() {
    if (this.vrButton !== null)
      this.vrButton.style.display = window.fullscreenFlag ? "none" : "block";
    if (this.arButton !== null)
      this.arButton.style.display = window.fullscreenFlag ? "none" : "block";
  }
}
